import { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { AWStageDto } from '@api/Api';

export function useCurrentStage({
  stages,
  currentStageId,
  isFinished,
  isPaused
}: {
  stages: AWStageDto[];
  currentStageId: string | null | undefined;
  isFinished?: boolean;
  isPaused?: boolean;
}) {
  const currentStage = useMemo(() => {
    if (!stages?.length) return null;
    return stages.find((stage) => stage.id === currentStageId) || stages[0];
  }, [stages, currentStageId]);

  const deadlineMoment = useMemo(() => {
    if (!currentStage?.deadline) return null;
    return moment(currentStage.deadline).startOf('minute');
  }, [currentStage?.deadline]);

  const [isPastDueDate, setIsPastDueDate] = useState(
    isFinished || isPaused || !deadlineMoment
      ? false
      : moment().startOf('minute').isSameOrAfter(deadlineMoment)
  );

  useEffect(() => {
    if (!deadlineMoment || isFinished || isPaused) {
      setIsPastDueDate(false);
      return;
    }

    const intervalId = setInterval(() => {
      setIsPastDueDate(
        moment().startOf('minute').isSameOrAfter(deadlineMoment)
      );
    }, 1000);

    return () => clearInterval(intervalId);
  }, [isFinished, isPaused, deadlineMoment]);

  return {
    currentStage,
    isPastDueDate,
    formattedDeadline: currentStage?.deadline
      ? moment(currentStage.deadline).format('MMM DD')
      : null
  };
}
